module.exports = __webpack_public_path__ + "img/GongLogoLarge.60a43bf3.png";